module.exports = __webpack_public_path__ + "images/red_highlight.2df68403eac6d308712c610f9474ade3.png";